module.exports = __webpack_public_path__ + "media/ne01-s1-intro.56e7fa33.mp4";